<template>
  <Dialog
    title="导入题库信息"
    :close-on-click-modal="false"
    :visible.sync="uploadVisible"
    width="400px"
    :before-close="uploadCancel"
  >
    <el-upload
      action="#"
      ref="uploadRef"
      accept=".xlsx"
      :on-change="handleChange"
      multiple
      :auto-upload="false"
      :disabled="isUploading"
      drag
      :limit="1"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或<em>点击上传</em>
        <div>支持文件格式xlsx，仅支持单个文件上传</div>
      </div>
      <div class="el-upload__tip" slot="tip">
        <div>1.试题表格中，需完整填写/选择所有内容项，不得为空</div>
        <div>2.多选题答案，需用英文逗号分隔，如：A,B,C,D</div>
        <div>3.判断题答案，只需填写A、B选项，C、D选项可为空</div>
      </div>
    </el-upload>
    <div slot="footer">
      <el-button
        plain
        round
        size="small"
        @click="downloadTemp"
        icon="el-icon-download"
        type="text"
        >下载模板</el-button
      >
      <el-button plain round size="small" @click="uploadCancel"
        >取 消</el-button
      >
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="isUploading"
        @click="uploadSubmit"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>
<script>
import { questionUpload } from "@/api/questionBank/theory";
export default {
  name: "TheoryBankUpload",
  data() {
    return {
      uploadVisible: false,
      isUploading: false,
      fileList: []
    };
  },
  methods: {
    uploadCancel() {
      this.uploadVisible = false;
      this.$refs.uploadRef.clearFiles();
      this.fileList = [];
    },
    async downloadTemp() {
      const res =
        process.env.NODE_ENV === "production"
          ? "./static/题库模版.xlsx"
          : "/static/题库模版.xlsx";
      window.open(res);
    },
    async uploadSubmit() {
      if (this.isUploading) return;
      await this.handleDocUpload();
    },
    async handleDocUpload() {
      if (this.isUploading) return;
      this.isUploading = true;
      try {
        const uploadForm = new FormData();
        if (this.fileList.length > 0) {
          this.fileList.forEach(item => {
            uploadForm.append("file", item.raw);
            uploadForm.append("questionBankId", this.$route.query.id);
          });
          await questionUpload(uploadForm).then(res => {
            this.isUploading = false;
            this.fileList = [];
            this.$refs.uploadRef.clearFiles();

            if (res.data && res.data.code === 500) {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            } else {
              this.$message({
                type: "success",
                message: "上传成功!"
              });
              this.$emit("success");
              this.uploadCancel();
            }
          });
        } else {
          this.$message.info("请选择文件");
        }
      } finally {
        this.isUploading = false;
      }
    },
    onExceed() {},
    open() {
      this.uploadVisible = true;
    },
    handleChange(file, fileList) {
      if (file.name.split(".").slice(-1) == "xlsx") {
        this.fileList = fileList;
      } else {
        this.$refs.uploadRef.clearFiles();
        this.$message({
          type: "warning",
          message: "请上传xlsx文件"
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/QuestionBank/theory/TheoryBankUpload.vue